import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import { SET_FEATURES } from './types';
import { fetchFeatures } from '~/services/user';
export default {
  setFeatures(_ref, _ref2) {
    var _this = this;
    return _asyncToGenerator(function* () {
      var {
        commit
      } = _ref;
      var {
        market,
        locale,
        sellerContextStoreId
      } = _ref2;
      try {
        var features = yield fetchFeatures({
          market,
          locale,
          logger: _this.$logger,
          sellerContextStoreId
        });
        commit(SET_FEATURES, features || []);
      } catch (e) {
        _this.$logger.error('Error fetching features', e);
      }
    })();
  }
};